import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Line,
  LineChart,
  XAxis,
  YAxis,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { useEffect, useState } from "react";
import axiosInstance from "@/utils/axiosInstance";

const chartConfig = {
  assignedOrders: {
    label: "Assigned",
    color: "hsl(var(--chart-1))",
  },
  completedOrders: {
    label: "Completed",
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig;

const VehiclePerformanceChart = ({
  range,
}: {
  range: { startDate: Date; endDate: Date };
}) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosInstance.get(`/reports/vehicle-performance`, {
          params: {
            startDate: range.startDate.toISOString().split("T")[0],
            endDate: range.endDate.toISOString().split("T")[0],
          },
        });

        setChartData(res.data);
      } catch (error) {
        console.error("Gabim gjatë marrjes së të dhënave:", error);
      }
    };

    fetchData();
  }, [range]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Vehicles by performance</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <LineChart
            accessibilityLayer
            data={chartData}
            // margin={{
            //     left: 12,
            //     right: 12,
            // }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="licensePlate"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <Line
              dataKey="assignedOrders"
              type="natural"
              stroke="var(--color-chart-dark-green)"
              strokeWidth={2}
              dot={{
                fill: "var(--color-chart-dark-green)",
              }}
              activeDot={{
                r: 6,
              }}
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default VehiclePerformanceChart;
